module.exports = __webpack_public_path__ + "static/avatar-c3d233d1a0066c25400a7d3d05626e65.jpg";